// Import model
import { UpdateReportDocumentTemplateRequest } from '../models/UpdateReportDocumentTemplateRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateReportDocumentTemplateRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateReportDocumentTemplateRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateReportDocumentTemplateRequest instance
   */
  static deserialize(json: string): UpdateReportDocumentTemplateRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateReportDocumentTemplateRequest instance
   */
  static fromObject(obj: any): UpdateReportDocumentTemplateRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateReportDocumentTemplateRequest');
    }


    const instance: UpdateReportDocumentTemplateRequest = {
      template: obj['Template'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateReportDocumentTemplateRequest instances
   */
  static deserializeArray(json: string): UpdateReportDocumentTemplateRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateReportDocumentTemplateRequest instance to a JSON string
   */
  static serialize(instance: UpdateReportDocumentTemplateRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateReportDocumentTemplateRequest instance to a plain object
   */
  static toObject(instance: UpdateReportDocumentTemplateRequest): any {
    return {
      'Template': instance.template,
      'isActive': instance.isActive,
      'name': instance.name,
      'description': instance.description,
    };
  }

  /**
   * Serializes an array of UpdateReportDocumentTemplateRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateReportDocumentTemplateRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
